import { IconName } from '@infotech-soe/erp-ui-kit';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import { ClientContext } from '../../context/IContextService';
import { CommandName } from '../CommandViewModel';
import CategoryCommandImpl from '../impl/CategoryCommandImpl';
import {
  UserInteractor,
  UserInteractorType,
  WorkTableType,
} from '../UserInteractor';

import CategoryCommand, { RefreshStrategy } from './CategoryCommand';

export class OpenPlanWorkTableCommand extends CategoryCommand<void> {
  constructor(
    commandImpl: CategoryCommandImpl<void>,
    private icon?: IconName
  ) {
    super(commandImpl);
  }
  public async getCaption(): Promise<Caption> {
    return {
      type: CaptionType.BUILT_IN,
      caption: BuiltinCaptionType.SET_PLAN_WORK,
    };
  }

  public getIcon(): IconName {
    return this.icon ?? 'calendar';
  }

  public isAvailable(context: ClientContext): boolean {
    return context.has('Id');
  }

  public getRefreshStrategy(): RefreshStrategy {
    return RefreshStrategy.NONE;
  }

  public async getUserInteractor(): Promise<UserInteractor> {
    return {
      type: UserInteractorType.WORK_TABLE,
      tableType: WorkTableType.PLAN,
    };
  }

  public getName(): CommandName {
    return 'openPlanWorkTable';
  }
}
